<div
  class="container"
  [ngClass]="{'container--basic': type === 'basic'}">
  <app-gradient class="gradient-right"></app-gradient>
  <div
    [ngClass]="{'content--large': maxWidth === 'large'}"
    class="content">
    <ng-content></ng-content>
  </div>
</div>
